import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { UsernameResponse } from './types';

/**
 * Retrieves username, first name, and last name of user with supplied user ID
 *
 * @method getUsername
 * @memberof User
 * @param  {number} userId - ID of user to get username from
 * @returns {Promise<UsernameResponse>} - First name, last name, and username of requested user
 */

export const getUsername = async (userId: number): Promise<UsernameResponse> => {
  return httpGet(`${Constants.BACKEND_URL}/user/${userId}`)
    .then((response) => {
      if (response?.status === 200) {
        const { first_name, last_name, login } = response.data;

        return {
          success: true,
          userData: {
            firstName: first_name,
            lastName: last_name,
            login,
          },
        };
      } else {
        return {
          success: false,
        };
      }
    })
    .catch(() => {
      return {
        success: false,
      };
    });
};
